import { h } from 'preact';
import CloseIcon from 'utils/icon/icon-close-filters.svg';

const SelectedFilters = () => {
  const data = ['Size M', 'Short Sleeve', 'Crew Neck', 'Blue'];

  return (
    <ul className="container m-0 flex flex-wrap gap-8 border-b border-grey-5 p-15 l:border-b-0 l:border-t l:px-0 l:py-20">
      {data.map((el) => (
        <li
          className="list-none"
          key={el}
        >
          <button className="body-14-light flex items-center justify-center gap-4 bg-grey-6 px-8 py-[10px] text-primary">
            {el === 'Blue' && <span className="block h-[16px] w-[16px] rounded-full bg-[#75A0DB]"></span>}
            {el}
            <CloseIcon />
          </button>
        </li>
      ))}
      <li className="flex list-none items-center">
        <button className="body-12-light l:body-14-light flex items-center justify-center underline">
          {window.TMW.Strings.filters.clearAll}
        </button>
      </li>
    </ul>
  );
};

export default SelectedFilters;
